/* ==================================================================
   EDIT HERE — Customer portal frequency labels

   These override what the Awtomic customer portal shows under
   "Frequency". Without them the portal builds its own wording from the
   billing interval, so a plan set to every 4 months reads "Every 4
   months".

   Key   = Shopify selling plan id (the number, not the full gid)
   Value = exactly what the shopper sees, rendered verbatim

   This text WINS over the selling plan name in Shopify — the script
   rewrites the portal on every render. Changing the plan name in the
   Shopify admin alone will not change what shows here. Update the text
   below, and keep the plan name in Shopify in sync so the two agree.

   A subscription on any plan not listed here is left untouched.
   ================================================================== */
window.AWT_PORTAL_FREQUENCY_LABELS = {
    '710894453045': '3 times a year APRIL, SEPTEMBER, NOVEMBER',
    '710463488309': 'Delivered twice yearly (FEB, AUG)',
    '710463553845': 'Deliver every 1 month',
    '710463521077': 'Deliver every 2 months',
    '710469517621': 'Deliver every 3 months'
};

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign(
    {},
    window.bundleapp.settings || {},
    {
        bab: {
            productImage: 600
        }
    },
);

(function(){
    function onReady(cb){
        if (document.readyState === 'complete' || document.readyState === 'interactive'){
            cb();
        } else {
            document.addEventListener('DOMContentLoaded', cb);
        }
    }

    onReady(function(){
        var path = 'tools/bundle-subscriptions/bundle/10200573477173';
        if (window.location.href.indexOf(path) === -1) return;

        var selector = '.bundleapp-modal__container--complete-screen .bundle-container';
        var imgId = 'bundle-subscription-placeholder-img';

        var interval = setInterval(function(){
            var container = document.querySelector(selector);
            if (container){
                if (!document.getElementById(imgId)){
                    var imgContainer = document.createElement('div');
                    imgContainer.className = 'bundle-subscription-placeholder-img-container';

                    var img = document.createElement('img');
                    img.src = window.plp_banner_src;
                    img.id = imgId;

                    imgContainer.appendChild(img);

                    container.insertBefore(imgContainer, container.firstChild);

                    // var imgOverlay = document.createElement('div');
                    // imgOverlay.className = 'bundle-subscription-placeholder-img-overlay';
                    // imgContainer.appendChild(imgOverlay);

                    var imgText = document.createElement('div');
                    imgText.className = 'bundle-subscription-placeholder-img-text';
                    imgText.innerHTML = '<h1>Custom Subscription</h1>';
                    imgContainer.appendChild(imgText);

                    // insert HTML block below the image
                    var info = document.createElement('div');
                    info.className = 'bundle-subscription-info';
                    info.innerHTML = '<div class="bs-left"><h3>Build your own wine subscription</h3><p>Craft your own box—filled with the wines you love, delivered on your schedule, and made to savor life\'s most meaningful moments. Subscriptions include the most recently released vintage each year. Vintages update annually as new releases become available.</p></div><aside class="bs-right"><h4>Subscription Details</h4><ul><li>Flexible vintage mix, choose your favorite!</li><li>Set deliveries every 1, 2, or 3 months.</li><li>Your subscription unlocks exclusive access to The Oak Society.</li><li>Wines ship directly from our winery</li></ul></aside>';
                    container.insertBefore(info, imgContainer.nextSibling);
                    
                    // insert HTML block below the image
                    const createContent = document.querySelector('.bundle-create-content');
                    var itemsheader = document.createElement('div');
                    itemsheader.className = 'bundle-subscription-itemsheader';
                    itemsheader.innerHTML = '<div class="main-bab-header"><h3>Build your own wine subscription</h3><p>Craft your own box—filled with the wines you love</p></div>';
                    container.insertBefore(itemsheader, createContent);
                }
                clearInterval(interval);
            }
        }, 50);
    });

    // window.RemoveAwtCartBundle = async (bundle_id) => {
    //   if (!bundle_id) return;

    //   try {
    //     // Get current cart contents
    //     const cart = await (await fetch('/cart.js')).json();
    
    //     // Create data object for cart update AJAX call
    //     const data = {
    //       updates: cart.items.reduce((acc, item) => (
    //         (item.properties?._bundleUid == bundle_id) ? { ...acc, [item.key]: 0 } : acc
    //       ), {})
    //     };
    
    //     // API call to update the cart contents and set the bundle item quantities to 0
    //     const response = await fetch('/cart/update.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(data)
    //     });
    
    //     response.ok && (window.location.href = '/cart');
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }

})();

/* ------------------------------------------------------------------
   Customer portal: show the winery's own frequency wording.

   Reads the label table defined at the top of this file. Each
   subscription is matched on its selling plan id, so a subscription on
   any other plan is left alone.

   To change a label, edit AWT_PORTAL_FREQUENCY_LABELS at the top —
   nothing in here needs touching.
   ------------------------------------------------------------------ */
(function () {
    var PLAN_LABELS = window.AWT_PORTAL_FREQUENCY_LABELS || {};

    var DETAIL_SELECTOR = '.awt-frequency-container';
    var LIST_ITEM_SELECTOR = '[data-subscription-id]';
    var LIST_LABEL_SELECTOR =
        '.bundleapp-subscription-list-item__subscription-delivery-frequency';

    function planIdOf(subscription) {
        var lines = (subscription && subscription.Lines) || [];
        for (var i = 0; i < lines.length; i++) {
            var gid = lines[i] && lines[i].SellingPlanId;
            if (gid) {
                return String(gid).split('/').pop();
            }
        }
        return null;
    }

    function labelFor(subscription) {
        var id = planIdOf(subscription);
        return id ? PLAN_LABELS[id] || null : null;
    }

    // Write only when the text differs, so we never fight the portal's own
    // re-render or loop the observer.
    function setText(el, text) {
        if (!el || !text) return;
        var target = el.querySelector('span') || el;
        if (target.textContent.trim() !== text) {
            target.textContent = text;
        }
    }

    function applyDetail() {
        var awtomic = window.Awtomic || {};
        var label = labelFor(awtomic.subscriptionDetails);
        if (label) {
            setText(document.querySelector(DETAIL_SELECTOR), label);
        }
    }

    function applyList() {
        var items = (window.Awtomic || {}).subscriptionList || [];
        if (!items.length) return;

        var byId = {};
        items.forEach(function (item) {
            var id = String(item.SubscriptionId || '').split('/').pop();
            var label = labelFor(item);
            if (id && label) byId[id] = label;
        });

        var rows = document.querySelectorAll(LIST_ITEM_SELECTOR);
        Array.prototype.forEach.call(rows, function (row) {
            var label = byId[row.getAttribute('data-subscription-id')];
            if (label) {
                setText(row.querySelector(LIST_LABEL_SELECTOR), label);
            }
        });
    }

    function apply() {
        try {
            applyDetail();
            applyList();
        } catch (e) {
            // Never let this break the portal.
        }
    }

    // The portal is a React app: it renders after page load and re-renders
    // when the shopper edits the subscription. So watch the DOM as well as
    // listening for the portal's own ready event.
    var scheduled = false;
    function schedule() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
            scheduled = false;
            apply();
        });
    }

    window.addEventListener('awtomic-cp-loaded', schedule);

    function start() {
        apply();
        new MutationObserver(schedule).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.body) {
        start();
    } else {
        document.addEventListener('DOMContentLoaded', start);
    }
})();